import { AppSettings } from '@/app/AppSettings';

import { LogViewerTableRowCellModelData } from '../../LogViewerTableRowModel';

export interface LogEntryCellModelData extends LogViewerTableRowCellModelData {
  type: LogEntryCellType;
}

export interface LogEntryCellModelDelegate {
  onLogEntryCellModelChange(args: {
    cellModel: LogEntryCellModel;
    change: DeepPartial<LogEntryCellModelData>;
    postProcess: boolean;
  }): void;
}

export interface LogEntryCellModel {
  data: DeepReadonly<LogEntryCellModelData>;
  delegate?: LogEntryCellModelDelegate;

  applySettings(settings: AppSettings): void;
}

export enum LogEntryCellType {
  Generic,
  ReduxAction,
  NetworkRequest,
  NetworkResponse,
  NetworkBodyWithJq,
  MQTTMessage,
}
